import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {MovimientoTesoreriaPage} from '../../pages/movimiento-tesoreria/movimiento-tesoreria'
import {MovimientoTransferenciaTesoreriaPage} from '../../pages/movimiento-transferencia-tesoreria/movimiento-transferencia-tesoreria'
import { RepoteEstadocuentaPage } from '../../pages/repote-estadocuenta/repote-estadocuenta'
import {MovimientotesoreriaServiceProvider} from '../../providers/movimientotesoreria-service/movimientotesoreria-service'

/**
 * Generated class for the CuentaTesoreriaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cuenta-tesoreria',
  templateUrl: 'cuenta-tesoreria.html',
})
export class CuentaTesoreriaPage {

pages:any=[];

  constructor(private movservice: MovimientotesoreriaServiceProvider, public navCtrl: NavController, public navParams: NavParams)
  {
    this.pages= [ {
      title: 'Cuentas Bancarias', icon:'book',sub:[] },
      {
      title: 'Cuentas Internas', icon:'book',sub:[] }];

    this.movservice.getCuentasExternas().subscribe(val => {
      for (let elemento in val)
      {
        this.pages[0].sub.push({ title: val[elemento].descripcion,
          icon:'book', component:null,sub:[
            {title: 'Depósito', component: MovimientoTesoreriaPage, icon:'add', idcuenta:val[elemento].id, idoperacion:1, idtmovimiento:9}
            ,{title: 'Cheque', component: MovimientoTesoreriaPage, icon:'remove', idcuenta:val[elemento].id, idoperacion:2, idtmovimiento:8}
            , {title: 'Nota de crédito', component: MovimientoTesoreriaPage,icon:'add',idcuenta:val[elemento].id, idoperacion:1, idtmovimiento:19},
            {title: 'Nota de débito', component: MovimientoTesoreriaPage,icon:'remove', idcuenta:val[elemento].id, idoperacion:2, idtmovimiento:18}
          ] });
      }
    });

    this.movservice.getCuentasInternas().subscribe(val => {
      for (let elemento in val)
      {
        this.pages[1].sub.push({ title: val[elemento].descripcion,
          icon:'book', component:null,sub:[
            {title: 'Nota de crédito', component: MovimientoTesoreriaPage,icon:'add',idcuenta:val[elemento].id, idoperacion:1, idtmovimiento:19},
            {title: 'Egreso de efectivo', component: MovimientoTesoreriaPage,icon:'remove', idcuenta:val[elemento].id, idoperacion:2, idtmovimiento:18}
          ] });
      }
    });



    /*
  	this.pages= [ {
        title: 'Cuentas Bancarias', icon:'book' ,
        sub: [
		{title: 'Corriente Bco. Gye. #12311 con un saldo de $700', icon:'book' ,component: null,
		sub: [
		{title: 'Depósito', component: MovimientoTesoreriaPage, icon:'add'}
		,{title: 'Cheque', component: MovimientoTesoreriaPage, icon:'remove'}
		, {title: 'Nota de crédito', component: MovimientoTesoreriaPage,icon:'add'},
		 {title: 'Node de débito', component: MovimientoTesoreriaPage,icon:'remove'}
		]},
		{title: 'Ahorro Bco. Pacifico #1111 con un saldo de $1800', icon:'book' , component: null
		,sub:[
		{title: 'Nota de crédito', component: MovimientoTesoreriaPage,icon:'add'},
		 {title: 'Node de débito', component: MovimientoTesoreriaPage,icon:'remove'}

		]
		}
		,
		{title: 'Ahorro Bco. Internacional #6665 con un saldo de $5000', icon:'book'
		, sub:
		[
		{title: 'Nota de crédito', component: null, icon:'add'},
		 {title: 'Nota de débito', component: null, icon:'remove'},
		 {title: 'Otros movimientos', sub: [
		{title: 'Otros ingresos', component: null},
		{title: 'Otros egresos', component: null}
		]}
		]}
		]


  		}
  		];
  		*/

  		this.pages.push({title: 'Transferencia entre cuenta', component: MovimientoTransferenciaTesoreriaPage})

  		this.pages.push({title: 'Reportes', icon:'apps' , sub: [
			{title: 'Estado de Cuenta', component: RepoteEstadocuentaPage, icon:'cloudy'}

		 	]
		 });
  }

  ionViewDidLoad()
  {
    console.log('ionViewDidLoad CuentaTesoreriaPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/cuenta-tesoreria/cuenta-tesoreria.ts